export interface FemaleToMaleRatioData {
  maleCount: number;
  femaleCount: number;
}

export interface FemaleToMaleAPIResponse {
  '0-18': FemaleToMaleRatioData;
  '19-26': FemaleToMaleRatioData;
  '27-40': FemaleToMaleRatioData;
  '41-64': FemaleToMaleRatioData;
  '65+': FemaleToMaleRatioData;
}

export interface MemberTableDataAPIResponse {
  age_group: string;
  avg_paid: number;
  count: number;
  gender: string;
  pmpm: number;
  role: string;
  total_plan_paid: number;
  usage_percentage: number;
}

export interface EnrollmentMetricsAPIResponse {
  subscriptionType: string;
  count: number;
}

export interface EnrollmentChartFormat {
  label: string;
  value: string;
}

export interface PlanDistributionAPIResponse {
  plan_name: string;
  total_members_count: number;
}

export const formatEnrollmentAnalysis = (data: any) => {
  const result: any = {
    data: [],
    xAxisValues: [],
  };

  const monthArray: string[] = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  const subscriptionMap: {
    [key: string]: { [label: string]: number };
  } = {};

  const labels: string[] = [];
  const labelToIndexMap: { [label: string]: number } = {};

  // Step 1: Build 12-month xAxis labels
  let currentMonth = data.startFromMonth;
  let currentYear = data.startFromYear;

  for (let i = 0; i < 12; i++) {
    const label = `${monthArray[currentMonth - 1]} <br/> ${currentYear}`;
    labels.push(label);
    labelToIndexMap[label] = i;

    result.xAxisValues.push({ label });

    currentMonth++;
    if (currentMonth > 12) {
      currentMonth = 1;
      currentYear++;
    }
  }

  // Step 2: Get all unique subscription types
  const allSubscriptionTypes = new Set<string>();
  data.analysisData.forEach((item: any) => {
    if (item.subscription_type) {
      allSubscriptionTypes.add(item.subscription_type);
    }
  });

  // Step 3: Group actual data by subscription_type and label
  data.analysisData.forEach((item: any) => {
    const { subscription_type, month, year, totalEnrollments } = item;

    const label = `${monthArray[month - 1]} <br/> ${year}`;
    if (!(label in labelToIndexMap)) {
      return;
    }

    if (!subscriptionMap[subscription_type]) {
      subscriptionMap[subscription_type] = {};
    }

    subscriptionMap[subscription_type][label] = totalEnrollments;
  });

  // Step 4: Ensure each subscription type has values for all 12 months
  allSubscriptionTypes.forEach((subscription_type) => {
    const valuesMap = subscriptionMap[subscription_type] || {};
    const values = labels.map((label) => ({
      value: valuesMap[label] ?? 0,
    }));

    result.data.push({
      subscription_type,
      values,
    });
  });

  return result;
};
